import React, { Component } from "react";
import Zmage from "react-zmage";
import Fade from "react-reveal";

let id = 0;
class Patronat extends Component {
  render() {
     
   
    return (

        <section id="patronat">
          <div className="row">
            <div className="twelve columns ">
              <h2>Patronat</h2>
              <img
                className="howtoget-img"
                src = "images\patronat.jpg"
                alt="Patronat"
              />

            </div>
          </div>
        </section>

    );
  }
}

export default Patronat
